module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_alvdalen-9e024b85ac6f6f8fd44c64b01a00d8dd.png";